/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React__default from 'react';
import OverflowMenuItem from '../OverflowMenuItem/OverflowMenuItem.js';

const TableToolbarAction = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default.createElement(OverflowMenuItem, _extends({
    ref: ref,
    itemText: children
  }, rest));
});
TableToolbarAction.displayName = 'TableToolbarAction';
TableToolbarAction.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired
};

export { TableToolbarAction as default };
